module.exports = __webpack_public_path__ + "img/weather04.5a5b158b.png";